import { render } from "./FulfilmentAmountRow.vue?vue&type=template&id=145a1420"
import script from "./FulfilmentAmountRow.vue?vue&type=script&lang=js"
export * from "./FulfilmentAmountRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__